import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterSelect } from './filters/filter_select';
import { addLoadIndexAbsoluteValueToLabel } from '../../../../../_modules/tyre_index/add_load_index_absolute_value_to_label';
import TranslationContainer from '../../../translation/translation_container';
import Tooltip from '../../../tooltip/tooltip';
import getTranslatedText from '../../../../helper/get_translated_text';
import { getSpeedIndexAbsoluteValue } from '../../../../../_modules/tyre_index/get_speed_index_for_absolute_value';
import { Filters } from '../../../../constants/filter/filters';
import Translation from '../../../translation/translation';
import { map } from '../../../../../../lib/utilities';


function TyreIndex(props) {
    const opened = props.opened || !!props.loadIndexValue || !!props.speedIndexValue;

    const rawLoadIndexOptions = map(props.loadIndexOptions, option => [ option[0], addLoadIndexAbsoluteValueToLabel(option[0]) ]);
    const rawSpeedIndexOptions = map(props.speedIndexOptions, option => {
        const speedIndex = getSpeedIndexAbsoluteValue(option[0]);
        return [
            option[0],
            getTranslatedText('speed-index-absolute-value-hint', {
                SPEED_INDEX: speedIndex,
                ABSOLUTE_VALUE: option[0]
            }),
        ];
    });

    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline='catalog-filters-section-headline-tyre-index'
            containerModifier="tyre-index"
        >
            <p className="catalog-filter-section__hint-text">
                <Translation
                    translationKey="catalog-filter-tyre-index-note"
                />
                {' '}
                <TranslationContainer
                    targetProperties={{
                        content: { translationKey: 'catalog-filter-tyre-index-note-tooltip-text' },
                        label: { translationKey: 'catalog-filter-tyre-index-note-tooltip-link' }
                    }}
                >
                    <Tooltip
                        content="will-be-replaced"
                        additionalClassNames={['catalog-filter-section__hint-text-more']}
                    />
                </TranslationContainer>
            </p>

            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-load-index-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.LOAD_INDEX}
                    value={props.loadIndexValue}
                    options={rawLoadIndexOptions}
                    labelTranslationKey="catalog-configurator-load-index-select-label"
                    provideAllTranslationKey="catalog-configurator-load-index-select-label-all"
                    onChange={props.onLoadIndexChange}
                    onToolTipHover={() => props.onToolTipHover('Load Index')}
                    provideAllOption={true}
                    tooltipContent="will-be-replaced"
                    highlight={!props.loadIndexValue}
                />
            </TranslationContainer>

            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-speed-index-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.SPEED_INDEX}
                    value={props.speedIndexValue}
                    options={rawSpeedIndexOptions}
                    labelTranslationKey="catalog-configurator-speed-index-select-label"
                    provideAllTranslationKey="catalog-configurator-speed-index-select-label-all"
                    onChange={props.onSpeedIndexChange}
                    onToolTipHover={() => props.onToolTipHover('Speed Index')}
                    provideAllOption={true}
                    tooltipContent="will-be-replaced"
                    highlight={!!props.loadIndexValue && !props.speedIndexValue}
                />
            </TranslationContainer>
        </FilterSection>
    );
}

TyreIndex.propTypes = {
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    speedIndexValue: PropTypes.number.isRequired,
    loadIndexValue: PropTypes.number.isRequired,
    speedIndexOptions: PropTypes.array.isRequired,
    loadIndexOptions: PropTypes.array.isRequired,
    availableSpeedIndexOptions: PropTypes.array.isRequired,
    availableLoadIndexOptions: PropTypes.array.isRequired,
    onToolTipHover: PropTypes.func.isRequired,
    onLoadIndexChange: PropTypes.func.isRequired,
    onSpeedIndexChange: PropTypes.func.isRequired,
};

export { TyreIndex };
